(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meh-video-reel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('meh-video-reel')) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;

    customElements.define('meh-video-reel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-vr-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-vr-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-vr-dot]'));
        this.auto = this.dataset.autoplay === 'true' && !reduceMotion && !saveData;
        this.userPaused = new WeakSet();

        this.slides.forEach(function (slide) {
          var v = slide.querySelector('[data-vr-video]');
          if (!v) return;
          v.muted = true;
          v.setAttribute('muted', '');
          v.playsInline = true;
          v.addEventListener('playing', function () { slide.classList.add('is-playing'); });
          v.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
        });

        /* Play videos only while they are on screen */
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target.querySelector('[data-vr-video]');
              if (!v) return;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                if (self.auto && !self.userPaused.has(v)) self.play(v);
              } else {
                v.pause();
              }
            });
          }, { threshold: [0, 0.6] });
          this.slides.forEach(function (s) { self.io.observe(s); });
        }

        this.onClick = function (e) {
          var playBtn = e.target.closest('[data-vr-play]');
          var soundBtn = e.target.closest('[data-vr-sound]');
          var dot = e.target.closest('[data-vr-dot]');
          if (playBtn) {
            var v = playBtn.closest('[data-vr-slide]').querySelector('[data-vr-video]');
            if (v.paused) { self.userPaused.delete(v); self.play(v); }
            else { self.userPaused.add(v); v.pause(); }
          } else if (soundBtn) {
            self.toggleSound(soundBtn);
          } else if (dot) {
            self.goTo(Number(dot.dataset.vrDot));
          }
        };
        this.addEventListener('click', this.onClick);

        /* Dots follow the swipe on mobile */
        if (this.track && this.dots.length) {
          this.onScroll = function () {
            cancelAnimationFrame(self.raf);
            self.raf = requestAnimationFrame(function () { self.updateDots(); });
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
        }

        this.onVisibility = function () {
          if (document.hidden) self.slides.forEach(function (s) {
            var v = s.querySelector('[data-vr-video]');
            if (v) v.pause();
          });
        };
        document.addEventListener('visibilitychange', this.onVisibility);

        /* Theme editor: show the selected video */
        this.onBlockSelect = function (e) {
          var i = self.slides.findIndex(function (s) { return s.contains(e.target) || s === e.target; });
          if (i > -1) self.goTo(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        this.removeEventListener('click', this.onClick);
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      play(v) {
        if (v.preload === 'none') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      toggleSound(btn) {
        var slide = btn.closest('[data-vr-slide]');
        var v = slide.querySelector('[data-vr-video]');
        var turnOn = v.muted;
        /* Only one video with sound at a time */
        this.querySelectorAll('[data-vr-sound]').forEach(function (b) {
          var other = b.closest('[data-vr-slide]').querySelector('[data-vr-video]');
          other.muted = true;
          b.setAttribute('aria-pressed', 'false');
        });
        v.muted = !turnOn;
        btn.setAttribute('aria-pressed', String(turnOn));
        if (turnOn) { this.userPaused.delete(v); this.play(v); }
      }

      goTo(i) {
        var slide = this.slides[i];
        if (!slide || !this.track) return;
        if (this.track.scrollWidth > this.track.clientWidth) {
          var left = slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;
          this.track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      updateDots() {
        var t = this.track;
        var center = t.scrollLeft + t.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        this.slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        this.dots.forEach(function (d, i) {
          if (i === best) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
